import { Modal, Table, TableColumnsType } from "antd"
import React, { useEffect } from "react"
import { useRegister } from "../../contexts/RegisterContext"
import { useStore } from "../../contexts/StoreContext"
import useAuth from "../../hooks/useAuth"
import { useConfig } from "../../contexts/ConfigContext"
import { useCompany } from "../../contexts/CompanyContext"
import { useStoreFetch } from "../../hooks/useInventory"
import { TInventoryFirestore } from "../../models/storageModel"
type modalProps = {
  inventoryData:TInventoryFirestore[]
}
function InventoryModalData({inventoryData}:Readonly<modalProps>){

  const {register,updateRegister} = useRegister()
  const {store,updateStore} = useStore()
  const {config} = useConfig()
  const {company} = useCompany()
  const {tokenData} = useAuth.useToken('authCsrfToken',config.session,config.key)
  const {data:storeData} = useStoreFetch(tokenData,{
    all:true,
    company:company.current?.uid
  })
  useEffect(()=>{
    if(storeData?.storehouse){
      updateStore({list: storeData.storehouse})
    }
  },[storeData])
  
  const columnsItems:TableColumnsType = [
    {title:"#",dataIndex:"register"},
    {title:"Almacén",dataIndex:"name"},
    {title:"Cantidad",dataIndex:"quantity"},
  ]
  const inventoryList = (inventoryData || []).map((el,i) => ({
    key: i,
    register: i + 1,
    quantity: el.quantity,
    name: store.list.find(elStore => elStore.uid === el.uid)?.name || "DEFAULT"
  }))
  return(
    <Modal 
      title={<div style={{ textAlign: "center" }}>Detalle de existencias en almacén</div>} 
      open={register.showInventory}
      maskClosable={false}
      className="modal-responsive-md"
      onCancel={()=>updateRegister({showInventory:false})}
      onOk={()=>updateRegister({showInventory:false})}>
      <Table 
        rowClassName={"no-padding-rows"} 
        columns={columnsItems} 
        dataSource={inventoryList} 
        size="small" 
        pagination={false} 
        scroll={{x:"max-content"}}>
      </Table>
    </Modal>
  )
}

export default InventoryModalData